<template>
  <div class="container">
    <Header></Header>

    <div class="airport-msg">
      <p class="name">
        <span v-text="airportName"></span> -
        <span v-text="iataCode"></span>
      </p>
      <p class="addr">
        <span v-text="airportCity"></span>,
        <span v-text="airportCountry"></span>
      </p>
    </div>

    <div class="terminal">
      <div class="terminal-left">
        <div class="terminal-filter">
          <div class="terminal-filter-inner">
            <p>Filter</p>
            <div class="select" @click="showTerminalEvent">
              <div v-text="selectTerminal"></div>
              <img src="../assets/images/icon-arrow-down.svg" alt />
            </div>
          </div>
          <ul
            class="list"
            v-show="showTerminalList"
            v-for="item in terminalSelectList"
            :key="item.code"
          >
            <li v-text="item.name" @click="selectTerminalEvent(item.code, item.name)"></li>
          </ul>
        </div>

        <ul class="terminal-list">
          <li
            @click="showLoungeDetailEvent(item.code)"
            v-for="item in terminalList"
            :key="item.code"
            :class="{'selected': terminalCode === item.code}"
          >
            <img
              :src="item.loungeImages.length === 0 ? 'http://image.dragonpass.com.cn/uploadFile/images/lounge/default/defaultRoom.jpg' : item.loungeImages[0]"
              alt
            />
            <div class="msg">
              <p class="name" v-text="item.name"></p>
              <p class="time" v-text="item.openingHours"></p>
              <p class="addr">
                <span v-text="item.terminal"></span>,
                <span v-text="item.inspection"></span>
              </p>
            </div>
          </li>
        </ul>
      </div>
      <div class="terminal-right" v-if="terminalList.length > 0">
        <div class="terminal-detail" v-show="!showLoading">
          <h2 class="pc" v-text="loungeDetail.name"></h2>

          <div class="pc-slide">
            <div class="view">
              <swiper :options="swiperViewOption" class="swiper-container" ref="viewSwiper">
                <a
                  class="arrow-left"
                  href="javascript:;"
                  slot="button-prev"
                  @click="turnLeft"
                  v-show="loungeImages.length > 1"
                ></a>
                <a
                  class="arrow-right"
                  href="javascript:;"
                  slot="button-next"
                  @click="turnRight"
                  v-show="loungeImages.length > 1"
                ></a>
                <swiperSlide
                  class="swiper-slide"
                  v-for="images in loungeImages"
                  :key="images"
                  v-show="loungeImages.length > 0"
                >
                  <img :src="images" alt />
                </swiperSlide>
                <img
                  v-show="loungeImages.length === 0"
                  :src="'http://image.dragonpass.com.cn/uploadFile/images/lounge/default/defaultRoom.jpg'"
                  alt
                />
              </swiper>
              <div class="page">
                <span v-text="activeIndex+1"></span>/
                <span v-text="loungeImages.length"></span>
              </div>
            </div>

            <div class="preview" v-show="loungeImages.length > 1">
              <swiper :options="swiperPreviewOption" class="swiper-container" ref="previewSwiper">
                <swiperSlide
                  class="swiper-slide"
                  v-for="(images, idx) in loungeImages"
                  :key="images"
                  :class="{'active-nav': activeIndex === idx}"
                >
                  <img :src="images" alt />
                </swiperSlide>
              </swiper>
            </div>
          </div>

          <h2 class="mobile" v-text="loungeDetail.name"></h2>
          <h3>OPERATING HOURS</h3>
          <h4 v-text="loungeDetail.openingHours"></h4>
          <div class="line"></div>
          <h3>LOCATION</h3>
          <div class="location">
            <img src="../assets/images/icon-location-terminal@2x.png" alt />
            <div>
              <h4 v-text="loungeDetail.terminal">Terminal 1</h4>
              <h4 v-text="loungeDetail.leavingType">International Departure</h4>
              <h4 v-text="loungeDetail.boardingGate">Level 3</h4>
              <h4 v-text="loungeDetail.locationGuide">Near Boarding Gate: C1</h4>
            </div>
          </div>
          <div class="line"></div>
          <h3>AMENITIES</h3>
          <ul class="amenities">
            <li v-for="item in loungeDetail.amenities" :key="item.name">
              <img :src="item.icon" alt />
              <p v-text="item.name"></p>
            </li>
          </ul>
          <div style="height: 1px;width: 100%;background-color: #ddd;margin-top:10px;"></div>
          <h3>OVERVIEW</h3>
          <h4 v-text="loungeDetail.overview"></h4>
        </div>

        <div class="loading" v-show="showLoading">
          <img src="../assets/images/Page-loader-123px.svg" alt />
          <p>Loading</p>
        </div>
      </div>
      <div class="terminal-buy-wrap">
        <div class="terminal-buy-inner">
          <div class="terminal-buy-right">
            <div class="price-wrap">
              <span class="currency" v-text="currency"></span>
              <span class="price" v-text="totalPrice"></span>
            </div>
            <div class="num-wrap">
              <span class="name">Qty</span>
              <span class="minus" @click="decrement">
                <img src="../assets/images/btn-minus@2x.png" alt />
              </span>
              <span class="number" v-text="count"></span>
              <span class="plus" @click="increment">
                <img src="../assets/images/btn-plus@2x.png" alt />
              </span>
            </div>
            <div class="buy-btn" @click="buy">Buy Now</div>
          </div>
        </div>
      </div>
      <div class="terminal-layer" v-show="showTerminalList"></div>
    </div>
  </div>
</template>

<script>
import $ from "n-zepto";
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { mapState } from "vuex";
import Header from "@/components/Header";
// import Footer from "@/components/Footer";
import { setTimeout } from "timers";

export default {
  name: "terminal",
  data: function() {
    const vm = this;
    return {
      airportName: "",
      airportCountry: "",
      airporyCity: "",
      showLoading: false,
      showTerminalList: false,
      terminalSelectList: [],
      terminalList: [],
      selectTerminal: "All Terminals",
      selectTerminalCode: "",
      airportList: [],
      loungeImages: [],
      loungeDetail: {},
      terminalCode: "",
      activeIndex: 0,
      swiperViewOption: {
        loop: true,
        navigation: {
          nextEl: ".arrow-right",
          prevEl: ".arrow-left"
        }
      },
      swiperPreviewOption: {
        slidesPerView: "auto",
        allowTouchMove: true,
        on: {
          tap: function() {
            vm.viewSwiper.slideTo(this.clickedIndex, 1000);
            vm.previewSwiper.slideTo(this.clickedIndex, 1000);
            vm.activeIndex = this.clickedIndex;
          }
        }
      }
    };
  },
  components: {
    Header,
    // Footer,
    swiper,
    swiperSlide
  },
  created() {
    this.airportName = this.$route.query.airportName;
    this.airportCountry = this.$route.query.airportCountry;
    this.airportCity = this.$route.query.airportCity;
    this.iataCode = this.$route.query.iataCode;
  },
  mounted() {
    this.$axios
      .get("/api/lounge/findByAirportCode", {
        params: {
          airportCode: this.$route.query.airportCode,
          terminal: this.selectTerminalCode
        }
      })
      .then(res => {
        if (res.data.state === "11") {
          const list = res.data.data.list;
          let selectList = [];
          this.terminalList = list;
          if (list && list[0]) {
            this.initEvent(list[0].code);
            this.terminalCode = list[0].code;
            list.forEach(item => {
              selectList.push(item.terminal);
            });
            selectList = this.uniq(selectList);
            selectList = selectList.map(item => {
              return {
                code: item,
                name: item
              };
            });
            selectList.unshift({
              code: "",
              name: "All Terminals"
            });
            this.terminalSelectList = selectList;
          }
        }
      });
  },
  methods: {
    uniq(array) {
      var temp = []; //一个新的临时数组
      for (var i = 0; i < array.length; i++) {
        if (temp.indexOf(array[i]) == -1) {
          temp.push(array[i]);
        }
      }
      return temp;
    },
    increment() {
      this.$store.commit("increment");
    },
    decrement() {
      this.$store.commit("decrement");
    },
    toThousands(num) {
      var result = [],
        counter = 0;
      num = (num || 0).toString().split("");
      for (var i = num.length - 1; i >= 0; i--) {
        counter++;
        result.unshift(num[i]);
        if (!(counter % 3) && i != 0) {
          result.unshift(",");
        }
      }
      return result.join("");
    },
    buy() {
      //意图购买数据统计请求
      this.$axios
        .post(
          "/api/auxiliary/intentionPurchase",
          {},
          {
            headers: {
              language: this.$i18n.locale,
              token: localStorage.getItem("pass")
            }
          }
        )
        .then(res => {
          this.$router.push({ path: "/detail" });
        });
    },
    showTerminalEvent() {
      if (!this.showTerminalList) {
        this.showTerminalList = true;
      } else {
        this.showTerminalList = false;
      }
    },
    autoHeight() {
      setTimeout(() => {
        const leftHeight = $(".terminal-left").height();
        const rightHeight = $(".terminal-right").height();
        if (document.body.clientWidth > 640) {
          if (leftHeight < rightHeight) {
            $(".terminal-left").height(rightHeight);
          } else {
            $(".terminal-left").height(leftHeight);
          }
        } else {
          $(".terminal-left").height(leftHeight);
        }

        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
      }, 0);
    },
    initEvent(code) {
      this.showLoading = true;
      this.$axios
        .get("/api/lounge/findOneByLoungeCode", {
          params: {
            code
          }
        })
        .then(res => {
          if (res.data.state === "11") {
            this.loungeDetail = res.data.data;
            this.loungeImages = res.data.data.loungeImages;
            setTimeout(() => {
              this.showLoading = false;
              this.autoHeight();
            }, 500);
          }
        });
    },
    selectTerminalEvent(code, name) {
      this.selectTerminal = name;
      this.showTerminalList = false;
      this.$axios
        .get("/api/lounge/findByAirportCode", {
          params: {
            airportCode: this.$route.query.airportCode,
            terminal: code
          }
        })
        .then(res => {
          if (res.data.state === "11") {
            const list = res.data.data.list;
            this.terminalList = list;
            if (list && list[0]) {
              this.initEvent(list[0].code);
              this.terminalCode = list[0].code;
            }
          }
        });
    },
    showLoungeDetailEvent(code) {
      this.showLoading = true;
      this.terminalCode = code;
      this.activeIndex = this.viewSwiper.activeIndex = 0;
      this.$axios
        .get("/api/lounge/findOneByLoungeCode", {
          params: {
            code
          }
        })
        .then(res => {
          if (res.data.state === "11") {
            this.loungeDetail = res.data.data;
            this.loungeImages = res.data.data.loungeImages;
            this.showLoading = false;
            this.autoHeight();
            if (document.body.clientWidth < 640) {
              $(".terminal-left").hide();
              $(".terminal-right").show();
            }
          }
        });
    },
    turnLeft() {
      if (this.loungeImages.length > 1) {
        const activeIdx = this.viewSwiper.activeIndex - 1;
        if (activeIdx < 0) {
          this.viewSwiper.slideTo(this.viewSwiper.slides.length - 1, 1000);
          this.previewSwiper.slideTo(this.viewSwiper.slides.length - 1, 1000);
          this.activeIndex = this.viewSwiper.slides.length - 1;
          return;
        }
        this.viewSwiper.slideTo(activeIdx, 1000);
        this.previewSwiper.slideTo(activeIdx, 1000);
        this.activeIndex = activeIdx;
      }
    },
    turnRight() {
      if (this.loungeImages.length > 1) {
        const activeIdx = this.viewSwiper.activeIndex + 1;
        if (activeIdx > this.viewSwiper.slides.length - 1) {
          this.viewSwiper.slideTo(0, 1000);
          this.previewSwiper.slideTo(0, 1000);
          this.activeIndex = 0;
          return;
        }
        this.viewSwiper.slideTo(activeIdx, 1000);
        this.previewSwiper.slideTo(activeIdx, 1000);
        this.activeIndex = activeIdx;
      }
    }
  },
  computed: {
    count() {
      return this.$store.state.count;
    },
    currency() {
      return this.$store.state.currency;
    },
    price() {
      return this.toThousands(this.$store.state.price);
    },
    totalPrice() {
      return this.toThousands(this.$store.state.totalPrice);
    },
    viewSwiper() {
      return this.$refs.viewSwiper.swiper;
    },
    previewSwiper() {
      return this.$refs.previewSwiper.swiper;
    }
  }
};
</script>

<style scoped>
@import "../assets/css/swiper-3.4.2.min";

.airport-msg {
  height: 120px;
  background: url("../assets/images/bg-header-lounge-details@2x.png") no-repeat;
  background-size: 100% 100%;
  overflow: hidden;
}

.airport-msg .name {
  font-family: "Bold";
  font-size: 20px;
  color: #fff;
  margin-top: 30px;
  margin-left: 5%;
}

.airport-msg .addr {
  font-family: "Regular";
  font-size: 18px;
  color: #fff;
  margin-top: 10px;
  margin-left: 5%;
}

.terminal {
  width: 1200px;
  min-height: 500px;
  margin: 0 auto;
  overflow: hidden;
  position: relative;
  padding-bottom: 80px;
}

.terminal-layer {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  position: absolute;
  left: 0;
  top: 0;
  z-index: 10;
}

.terminal-left {
  float: left;
  width: 430px;
  height: auto;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px;
}

.terminal-right {
  float: right;
  width: 770px;
  position: relative;
}

.terminal-filter {
  width: 350px;
  height: 80px;
  background: #f5f6fa;
  position: relative;
  margin-left: 80px;
  z-index: 20;
}

.terminal-filter .list {
  background: #fff;
}

.terminal-filter .list li {
  height: 50px;
  line-height: 50px;
  border-bottom: 1px #ddd solid;
  font-family: "Regular";
  font-size: 14px;
  color: #2d354c;
  padding-left: 35px;
  cursor: pointer;
}

.terminal-filter .list li:last-child {
  border: none;
}

.terminal-filter-inner {
  overflow: hidden;
  padding-left: 20px;
}

.terminal-filter-inner p {
  font-family: "Bold";
  font-size: 12px;
  color: #333333;
  margin: 10px 0;
}

.terminal-filter-inner .select {
  display: inline-block;
  background: #7b8090;
  border-radius: 20px;
  cursor: pointer;
  overflow: hidden;
}

.terminal-filter-inner .select div {
  float: left;
  font-size: "Regular";
  height: 30px;
  line-height: 30px;
  font-size: 12px;
  color: #fff;
  padding: 0 16px;
}

.terminal-filter-inner .select img {
  float: left;
  width: 10px;
  height: 10px;
  padding: 11px 16px;
}

.terminal-list {
  padding: 20px 20px 0 100px;
}

.terminal-list li {
  width: 310px;
  /* height: 100px; */
  min-height: 80px;
  border: 1px #dddddd solid;
  border-radius: 4px;
  margin-bottom: 20px;
  position: relative;
  cursor: pointer;
  padding: 10px 0;
}

.terminal-list .selected {
  border: 2px #910000 solid;
}

.terminal-list li img {
  width: 80px;
  height: 80px;
  position: absolute;
  left: 10px;
  top: 10px;
}

.terminal-list .msg {
  padding-left: 100px;
}

.terminal-list .msg .name {
  font-family: "Bold";
  font-size: 14px;
  color: #910000;
}

.terminal-list .msg .time {
  font-family: "Regular";
  font-size: 12px;
  color: #7b8090;
  margin: 5px 0;
}

.terminal-list .msg .addr {
  font-family: "Regular";
  font-size: 12px;
  color: #7b8090;
}

.terminal-detail {
  width: 618px;
  margin: 20px;
  padding-bottom: 80px;
}

.terminal-detail .line {
  height: 1px;
  width: 100%;
  background-color: rgb(221, 221, 221);
  margin-top: 20px;
}

.terminal-detail h2 {
  font-family: "Bold";
  font-size: 24px;
  color: #333333;
  margin-bottom: 20px;
}

.terminal-detail .pc {
  display: block;
}

.terminal-detail .mobile {
  display: none;
}

.terminal-detail h3 {
  font-family: "SemiBold";
  font-size: 18px;
  color: #2d354c;
  margin: 20px 0 10px;
}

.terminal-detail h4 {
  font-family: "Regular";
  font-size: 14px;
  font-weight: normal;
  color: #2d354c;
  margin-bottom: 10px;
  line-height: 22px;
}

.terminal-detail .location {
  position: relative;
}

.terminal-detail .location img {
  width: 30px;
  height: 30px;
  position: absolute;
  left: 0;
  top: 0;
}

.terminal-detail .location div {
  padding-left: 40px;
}

.terminal-detail .amenities {
  overflow: hidden;
}

.terminal-detail .amenities li {
  float: left;
  width: 50%;
  height: 40px;
  position: relative;
  margin-bottom: 10px;
}

.terminal-detail .amenities img {
  width: 30px;
  height: 30px;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  margin: auto;
}

.terminal-detail .amenities p {
  font-family: "Regular";
  padding-left: 40px;
  font-size: 14px;
  color: #2d354c;
  margin: 11px 0;
}

.terminal-buy-wrap {
  width: 100%;
  height: 80px;
  position: fixed;
  left: 0;
  bottom: 0;
  background: #fff;
  box-shadow: rgba(0, 0, 0, 0.16) 0px -3px 3px;
  z-index: 100;
}

.terminal-buy-inner {
  width: 1200px;
  height: 100%;
  margin: 0 auto;
}

.terminal-buy-right {
  width: 770px;
  float: right;
  position: relative;
}

.terminal-buy-right .price-wrap {
  position: absolute;
  left: 3%;
  top: 25px;
  color: #910000;
}

.terminal-buy-right .price-wrap .currency {
  font-family: "Regular";
  font-size: 22px;
  height: 30px;
  line-height: 30px;
}

.terminal-buy-right .price-wrap .price {
  font-family: "Bold";
  font-size: 26px;
  height: 30px;
  line-height: 30px;
}

.terminal-buy-right .num-wrap {
  position: absolute;
  top: 20px;
  right: 350px;
}

.terminal-buy-right .num-wrap > span {
  float: left;
  width: 40px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  cursor: pointer;
}

.terminal-buy-right .num-wrap .name {
  font-size: 14px;
  color: #333333;
}

.terminal-buy-right .num-wrap img {
  width: 100%;
  height: 100%;
}

.terminal-buy-right .num-wrap .number {
  width: 40px;
  height: 40px;
  border: 1px #333333 solid;
  border-radius: 4px;
  margin: -1px 4px;
  background: #fff;
}

.terminal-buy-right .buy-btn {
  position: absolute;
  top: 15px;
  right: 100px;
  width: 230px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  background: #910000;
  border-radius: 4px;
  font-size: 18px;
  color: #fff;
  cursor: pointer;
}

.pc-slide {
  width: 620px;
  margin: 0 auto;
}

.pc-slide img {
  width: 100%;
  height: 100%;
}

.view {
  position: relative;
  left: 0;
  top: 0;
}

.view .swiper-container {
  width: 620px;
  height: 410px;
}

.view .arrow-left {
  background: url("../assets/images/btn-img-left@2x.png") no-repeat;
  background-size: cover;
  position: absolute;
  left: 10px;
  top: 50%;
  margin-top: -20px;
  width: 40px;
  height: 40px;
  z-index: 10;
  outline: none;
}

.view .arrow-left:hover {
  background: url("../assets/images/btn-img-left-red@2x.png") no-repeat;
  background-size: cover;
}

.view .arrow-right {
  background: url("../assets/images/btn-img-right@2x.png") no-repeat;
  background-size: cover;
  position: absolute;
  right: 10px;
  top: 50%;
  margin-top: -20px;
  width: 40px;
  height: 40px;
  z-index: 10;
  outline: none;
}

.view .arrow-right:hover {
  background: url("../assets/images/btn-img-right-red@2x.png") no-repeat;
  background-size: cover;
}

.preview {
  width: 100%;
  margin-top: 10px;
  position: relative;
}

.preview .swiper-container {
  width: 620px;
  height: 64px;
}

.preview .swiper-slide {
  width: 90px;
  height: 60px;
  cursor: pointer;
  margin-right: 10px;
}

/* .preview .arrow-left {
  background: url("../images/btn-img-left@2x.png") no-repeat left top;
  position: absolute;
  left: 10px;
  top: 50%;
  margin-top: -9px;
  width: 9px;
  height: 18px;
  z-index: 10;
}

.preview .arrow-right {
  background: url("../images/btn-img-right@2x.png") no-repeat left bottom;
  position: absolute;
  right: 10px;
  top: 50%;
  margin-top: -9px;
  width: 9px;
  height: 18px;
  z-index: 10;
} */

.preview img {
  padding: 2px;
  width: 100%;
  height: 100%;
}

.preview .active-nav img {
  padding: 0;
  border: 2px solid #910000;
}

.terminal-right .loading {
  width: 90px;
  margin: 100px auto;
}

.terminal-right .loading img {
  width: 60px;
  height: 60px;
  margin: 0 auto;
}

.terminal-right .loading p {
  height: 23px;
  line-height: 23px;
  margin-top: 10px;
  font-size: 17px;
  color: #555555;
  text-align: center;
}

.pc-slide .page {
  background: rgba(0, 0, 0, 0.6);
  padding: 4px 8px;
  border-radius: 4px;
  position: absolute;
  left: 18px;
  bottom: 14px;
  font-family: "Regular";
  font-size: 12px;
  color: #fff;
  z-index: 99;
  display: none;
}

@media screen and (max-width: 640px) {
  .airport-msg {
    height: 80px;
  }

  .airport-msg .name {
    font-size: 14px;
    margin-top: 20px;
  }

  .airport-msg .addr {
    font-size: 12px;
  }

  .terminal,
  .terminal-left,
  .terminal-right {
    width: 100%;
  }

  .terminal {
    min-height: 300px;
    padding-bottom: 120px;
  }

  .terminal-left {
    box-shadow: none;
  }

  .terminal-left,
  .terminal-right {
    position: relative;
    left: 0;
    top: 0;
  }

  .terminal-filter-inner {
    padding-left: 5%;
  }

  .terminal-list {
    padding: 10px;
  }

  .terminal-list li {
    width: 100%;
    min-height: 110px;
    border: none;
    padding: 10px 0;
    border-bottom: 1px #cccccc solid;
    margin-bottom: 0;
  }

  .terminal-filter .list li {
    padding-left: 10%;
  }

  .terminal-list .selected {
    border: none;
    border-bottom: 1px #cccccc solid;
  }

  .terminal-list li img {
    width: 110px;
    height: 110px;
    left: 0;
  }

  .terminal-list .msg {
    padding-left: 120px;
  }

  .terminal-detail {
    width: 100%;
    margin: 0;
  }

  .terminal-detail .pc,
  .preview,
  .airport-msg {
    display: none;
  }

  .terminal-detail .mobile {
    display: block;
    font-size: 18px;
    line-height: 24px;
    padding: 20px;
    border-bottom: 1px #dddddd solid;
  }

  .terminal-detail h3 {
    margin: 20px 20px 10px;
  }

  .terminal-detail h4 {
    margin-left: 20px;
  }

  .terminal-detail .amenities {
    padding: 0 20px;
  }

  .pc-slide {
    width: 100%;
  }

  .view .swiper-container {
    width: 100%;
    height: 230px;
  }

  .terminal-detail .location img {
    left: 20px;
  }

  .terminal-buy-wrap {
    height: 120px;
    background: #ededed;
    box-shadow: rgba(0, 0, 0, 0.16) -4px -4px 6px;
  }

  .terminal-buy-inner {
    width: 100%;
  }

  .terminal-buy-right {
    width: 100%;
  }

  .terminal-buy-right .num-wrap {
    min-width: 170px;
    right: 5%;
    top: 10px;
  }

  .terminal-buy-right .price-wrap {
    top: 15px;
    left: 5%;
  }

  .terminal-buy-right .buy-btn {
    width: 90%;
    top: 60px;
    left: 0;
    right: 0;
    margin: auto;
  }

  .terminal-right {
    display: none;
  }

  .terminal-detail h2 {
    margin-bottom: 0;
  }

  .pc-slide .page {
    display: block;
  }

  .terminal-filter {
    width: 100%;
    margin-left: 0;
  }
}

/* @media screen and (max-width: 320px) {
  .terminal-buy-right .num-wrap {
    float: right;
    width: 50%;
    margin: 15px 0;
  }

  .terminal-buy-right .num-wrap > span {
    width: 30px;
    height: 30px;
    line-height: 30px;
  }

  .terminal-buy-right .num-wrap .number {
    width: 30px;
    height: 30px;
  }
} */
</style>





// WEBPACK FOOTER //
// src/views/Terminal.vue